import { render, staticRenderFns } from "./HotelDetails.vue?vue&type=template&id=25e27e96&scoped=true&"
import script from "./HotelDetails.vue?vue&type=script&lang=js&"
export * from "./HotelDetails.vue?vue&type=script&lang=js&"
import style0 from "./HotelDetails.vue?vue&type=style&index=0&id=25e27e96&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e27e96",
  null
  
)

export default component.exports